import { GridItemNormalizer } from '../types';

export default class WorkTypeObjectNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return value?.__typename === 'object_Work';
  }

  normalize(value: any) {
    return value?.name;
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  getRequiredFields() {
    return {
      id: '',
      name: '',
    };
  }
}
